import React, { useState, useEffect } from "react";
import Container from "./container";
import { LabelContainer, FieldDescription } from "../controls/styled/container";
import StyledRowContainer, {
    StyledRowContainerItem
} from "../controls/styled/row-container";
import { evaluate, evaluateValues } from "../helper";
import Input from "./input";
import BoiReactMarkdown from "../../boi-markdown/boi-markdown";

const LoanCalculator = ({ ...props }) => {
    const [amountToBorrow, setAmountToBorrow] = useState("");
    const [loanTermInMonths, setLoanTermInMonths] = useState("");
    const [loanRepaymentFrequency, setLoanRepaymentFrequency] = useState("");
    const [variableRate, setVariableRate] = useState("");
    const [repaymentPerFrequency, setRepaymentPerFrequency] = useState("");
    const [totalRepaymentAmount, setTotalRepaymentAmount] = useState("");

    const calculateInputs = () => {
        setAmountToBorrow(
            evaluateValues(
                props.amountToBorrow || "",
                props.context ? props.context.getValues() : {}
            )
        );
        setLoanTermInMonths(
            evaluateValues(
                props.loanTermInMonths || "",
                props.context ? props.context.getValues() : {}
            )
        );
        setLoanRepaymentFrequency(
            evaluateValues(
                props.loanRepaymentFrequency || "",
                props.context ? props.context.getValues() : {}
            )
        );
        setVariableRate(
            evaluateValues(
                props.variableRate || "",
                props.context ? props.context.getValues() : {}
            )
        );
    };

    const calculateOutputs = () => {
        const r = `${variableRate} / 100 / (12 / ${loanRepaymentFrequency})`;
        const n = `${loanTermInMonths} / ${loanRepaymentFrequency}`;
        const newRepaymentPerFrequency = evaluate(
            `${amountToBorrow} * (${r} * pow(1 + ${r}, ${n})) / (pow(1 + ${r}, ${n}) - 1)`
        );
        const newTotalRepaymentAmount = evaluate(
            `${newRepaymentPerFrequency}*${n}`
        );
        if (
            newRepaymentPerFrequency !== repaymentPerFrequency ||
            newTotalRepaymentAmount !== totalRepaymentAmount
        ) {
            props.onChange({
                [props.inputs[0].id]: newRepaymentPerFrequency,
                [props.inputs[1].id]: newTotalRepaymentAmount
            });
            setRepaymentPerFrequency(newRepaymentPerFrequency);
            setTotalRepaymentAmount(newTotalRepaymentAmount);
        }
    };

    useEffect(() => {
        calculateInputs();
        calculateOutputs();
    });

    return (
        <Container {...props}>
            <StyledRowContainer>
                <StyledRowContainerItem>
                    <FieldDescription>
                        <BoiReactMarkdown>
                            {`Amount to borrow: ${amountToBorrow}`}
                        </BoiReactMarkdown>
                    </FieldDescription>
                </StyledRowContainerItem>
                <StyledRowContainerItem>
                    <FieldDescription>
                        <BoiReactMarkdown>
                            {`Loan term in months: ${loanTermInMonths}`}
                        </BoiReactMarkdown>
                    </FieldDescription>
                </StyledRowContainerItem>
            </StyledRowContainer>
            <StyledRowContainer>
                <StyledRowContainerItem>
                    <FieldDescription>
                        <BoiReactMarkdown>
                            {`Loan repayment frequency: ${loanRepaymentFrequency}`}
                        </BoiReactMarkdown>
                    </FieldDescription>
                </StyledRowContainerItem>
                <StyledRowContainerItem>
                    <FieldDescription>
                        <BoiReactMarkdown>
                            {`Variable rate: ${variableRate}`}
                        </BoiReactMarkdown>
                    </FieldDescription>
                </StyledRowContainerItem>
            </StyledRowContainer>
            <StyledRowContainer>
                <StyledRowContainerItem>
                    <LabelContainer>
                        <label className="field-sub-label">
                            Repayment per frequency
                        </label>
                    </LabelContainer>
                    <Input
                        className="u-width-100"
                        id={
                            props.id
                                ? `${props.id}_repayment_per_frequency`
                                : ""
                        }
                        value={repaymentPerFrequency}
                        readOnly
                    />
                </StyledRowContainerItem>
                <StyledRowContainerItem>
                    <LabelContainer>
                        <label className="field-sub-label">
                            Total repayment amount
                        </label>
                    </LabelContainer>
                    <Input
                        className="u-width-100"
                        id={
                            props.id ? `${props.id}_total_repayment_amount` : ""
                        }
                        value={totalRepaymentAmount}
                        readOnly
                    />
                </StyledRowContainerItem>
            </StyledRowContainer>
        </Container>
    );
};

export default LoanCalculator;
